require('./sectionTemplateEditorHeader.i18n.json');
require('./sectionTemplateEditorHeader.tpl.html');
require('./sectionTemplateEditorHeaderController.js');
require('./sectionTemplateActionRepository.js');
require('./sectionTemplateActionsUtil.js');

const SectionTemplateEditorHeaderComponent = {
    templateUrl: '/configuration/sectionTemplateEditor/header/sectionTemplateEditorHeader.tpl.html',
    controller: 'sectionTemplateEditorHeaderController',
    bindings: {}
};

angular.module('ums')
    .component('uiSectionTemplateEditorHeader', SectionTemplateEditorHeaderComponent);
